// src/components/DailyActivityReportView.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SignatureSvg from './SignatureSvg';

const REPORT_FIELDS = [
  { key: 'end_time',           label: 'End Time',           emoji: '🕐' },
  { key: 'activities_summary', label: 'Activities Summary', emoji: '📋' },
  { key: 'incidents',          label: 'Incidents',          emoji: '⚠️' },
  { key: 'measures_taken',     label: 'Measures Taken',     emoji: '🛠️' },
  { key: 'general_notes',      label: 'General Notes',      emoji: '📝' },
  { key: 'damaged_materials',  label: 'Damaged / Missing',  emoji: '🔧' },
];

const DailyActivityReportView = React.forwardRef(({ reportData, signatureSvg }, ref) => {
  if (!reportData) return <Typography>Loading...</Typography>;

  const { date, name, resort, completed_at } = reportData;

  const base = { fontFamily: '"Arial Narrow", Arial, sans-serif', fontSize: '8.5pt', color: '#111' };

  const fieldLabel = {
    ...base, fontWeight: 'bold', fontSize: '9pt',
    backgroundColor: '#f3f4f6', padding: '2px 6px',
    marginBottom: '2px', borderLeft: '3px solid #7c3aed',
  };

  return (
    <Box ref={ref} sx={{
      padding: '12px', backgroundColor: 'white', width: '780px',
      fontFamily: '"Arial Narrow", Arial, sans-serif', color: 'black',
      border: '1px solid black', boxSizing: 'border-box',
    }}>
      <Typography variant="h5" sx={{
        textAlign: 'center', fontWeight: 'bold', mb: 1, fontSize: '14pt',
        fontFamily: '"Arial Black", Gadget, sans-serif', textTransform: 'uppercase',
      }}>
        DAILY ACTIVITY REPORT
      </Typography>

      <Box sx={{ mb: 1 }}>
        <Typography sx={{ fontSize: '10pt', mb: 0.3 }}><b>DATE:</b> {date}</Typography>
        <Typography sx={{ fontSize: '10pt', mb: 0.3 }}><b>NAME:</b> {name}</Typography>
        <Typography sx={{ fontSize: '10pt', mb: 0.3 }}><b>RESORT:</b> {resort}</Typography>
        {completed_at && <Typography sx={{ fontSize: '9pt', color: '#555' }}><b>Submitted at:</b> {completed_at}</Typography>}
      </Box>

      <Box sx={{ borderTop: '1.5px solid #555', mb: 1 }} />

      {REPORT_FIELDS.map(({ key, label, emoji }) => {
        const val = reportData[key];
        if (!val) return null;
        return (
          <Box key={key} sx={{ mb: 1 }}>
            <Box sx={fieldLabel}>{emoji} {label}</Box>
            <Typography sx={{ ...base, px: '6px', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{val}</Typography>
          </Box>
        );
      })}

      {/* Assinatura — mesma do closing */}
      <Box sx={{ mt: 1.5, borderTop: '1.5px solid #555', pt: 1 }}>
        <Typography sx={{ ...base, fontWeight: 'bold', fontSize: '9pt', mb: 0.5 }}>EMPLOYEE SIGNATURE:</Typography>
        <SignatureSvg signatureSvgJson={signatureSvg} width={400} height={100} />
        <Typography sx={{ ...base, fontSize: '8pt', color: '#555', mt: 0.5 }}>
          By signing, I confirm that this daily activity report is truthful and accurate.
        </Typography>
      </Box>
    </Box>
  );
});

export default DailyActivityReportView;